import React from 'react'
import { ReactComponent as DefaultHeader } from '../../icon/default-header.svg'
import "../../css/HeaderImage.css"
import { PresetImage } from '../../library/Preset'
import { PropsWithTheme } from '../../library/Theme'

interface HeaderImageProps {
  image: PresetImage | null
}

function HeaderImage({ theme, image }: PropsWithTheme<HeaderImageProps>) {
  return (
    <header id="headerContainer">
      {(image && image.url) ?
        <img src={image.url} draggable={false} alt="Header" style={{ maxHeight: theme.headerMaxHeight }}/>
        :
        <DefaultHeader style={theme.svgStyleAlternate} />
      }
    </header>
  )
}

export default HeaderImage
